




































































import { State, Getter, Action, namespace } from 'vuex-class'
import { Vue, Prop, Component, Watch } from 'vue-property-decorator'
import _ from 'lodash'
import HttpRequestServiceWithToken from '@/services/HttpRequestServiceWithToken'
import { IPayment } from '@/store/modules/views/payment/states'
import VueExtendedBaseComponent from '@/VueExtendedBaseComponent.vue'
import { ICenter } from '@/store/modules/views/center/states'
import { IBank } from '@/store/modules/components/states'

@Component
export default class CreatePaymentDialog extends VueExtendedBaseComponent {

  get formInstant(): Vue & {
    validate: () => any
    resetValidation: () => any
    reset: () => any,
  } {
    return this.$refs.form as Vue & {
      validate: () => any
      resetValidation: () => any
      reset: () => any,
    }
  }

  @Getter('components/banks')
  private banks: IBank[]

  get openDialog() {
    return this.open
  }

  set openDialog(value: boolean) {
    this.$emit('update:open', false)
  }

  get createPaymentDialogOption() {
    return {
      justify: 'start',
      button: {
        justify: 'center',
        cancelButton: {
          title: 'ปิด',
          action: this.closeDialog,
          height: '30',
        },
        submitButton: {
          title: 'บันทึก',
          valiedate: true,
          action: this.createPaymentAction,
          loading: this.loading,
          height: '30',
        },
      },
    }
  }

  get validateInput() {

    return this.nameValidate(this.name)
  }
  @Prop() private open!: boolean
  @Prop() private callback!: () => Promise<void>
  @Prop() private payment!: IPayment & {roles: string[], permissions: string[], accounts: string[]}
  private loading = false
  private options = {
    page: 1,
    sortBy: ['createdAt'],
    sortDesc: [true],
    itemsPerPage: 1000,
    search: '',
  }
  private centeritems = ''
  private activePicker = null
  private valid = false
  private name = ''
  private bank: {name: string, text: string} = null
  private accountNumber = ''

  @Action('center/getCenterList')
  private getCentertList!: (headerParams: {
    headers: {
      page: number
      limit: number
      sortBy: string
      sortDesc: boolean
      search: string
      filter: string,
    },
  }) => void

  @Getter('center/centerLists')
  private centerItemLists!: () => void

  public async created() {
    await Promise.all([this.getCenterListFunc()])
  }

  private requireInput(value) {  return value !== '' || 'จำเป็นต้องกรอก' }

  get centerLists() {
    return this.centerItemLists
  }
  get invalidateInput() {
    return _.some([], (item) => item !== true)
  }

  private async getCenterListFunc() {
    await this.getCentertList({
      headers: {
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sortBy: _.get(this.options, 'sortBy[0]', 'createdAt'),
        sortDesc: _.get(this.options, 'sortDesc[0]', true),
        search: Buffer.from(this.options.search).toString('base64'),
        filter: Buffer.from(JSON.stringify({})).toString('base64'),
      },
    })
  }

  private async createPaymentAction() {
    const validate = this.formInstant.validate()
    if (validate) {
      this.loading = true
      const url = process.env.VUE_APP_API_URL + '/v1/all/payment'
      const paymentData = {
          name: this.name,
          accountNumber: this.accountNumber,
          bank: this.bank.name,
          centerId: this.centeritems,
      }
      this.loading = true
      try {
        await HttpRequestServiceWithToken.post(url, paymentData, async () => {
          this.updateSnackbar({txt: 'บันทึกบัญชีธนาคารสำเร็จ', type: 'success'})
          await this.callback()
          this.loading = false
          this.closeDialog()
        })
      } catch (e) {
        this.loading = false
      }
    }
  }

  private requireSelect(value) { return [(v) => !!v || 'จำเป็นต้องเลือก'] }

  private closeDialog() {
    this.$emit('update:open', false)
  }
}
